import { EntityListProductInputData } from '../entityListTypes';
import { ImportedItemRow } from '../../../../../lib/imports/importTypes';

/**
 * Converter is used to convert data pasted from Excel or text field to the input data for the entity list
 * and to convert structured data to the string ready to be sent to the backend.
 */
export abstract class EntityListItemConverter<T extends EntityListProductInputData> {
  convertFromNodes(cells: NodeListOf<HTMLTableCellElement>): Partial<T> {
    const textCells = Array.from(cells).map(cell => cell.firstChild?.textContent ?? '');
    return this.convertFromStrings(textCells);
  }

  abstract convertFromStrings(cells: string[]): Partial<T>;

  abstract convertToStructuredText(data: ImportedItemRow<T>[]): string;
}
